import cx from 'classnames'
import { useTranslation } from 'react-i18next'

const Nickname = ({
  user,
  className,
  hideTags = false,
  isGroupOwner,
  isGroupModerator,
}: {
  user: {
    nickname: string
    vip?: boolean
    title?: string
    hide_vip?: boolean
  }
  className?: string
  hideTags?: boolean
  isGroupOwner?: boolean
  isGroupModerator?: boolean
}) => {
  const { t } = useTranslation()

  return (
    <div className="Nickname">
      <div
        className={cx(
          'Nickname__wrapper',
          hideTags
            ? ''
            : isGroupOwner
            ? 'Nickname__wrapper--owner'
            : isGroupModerator
            ? 'Nickname__wrapper--moderator'
            : user?.title === 'admin'
            ? 'Nickname__wrapper--admin'
            : user?.title === 'official'
            ? 'Nickname__wrapper--official'
            : user?.vip && !user?.hide_vip
            ? 'Nickname__wrapper--vip'
            : '',
          className
        )}
        data-tag={
          isGroupOwner
            ? t('group_info_page.group_role_owner.title')
            : isGroupModerator
            ? t('group_info_page.group_role_moderator.title')
            : user?.title === 'admin'
            ? t('group.title.admin')
            : ''
        }
      >
        <span className="Nickname__span">{user?.nickname}</span>
      </div>
    </div>
  )
}

export default Nickname
